import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import About from "../components/About";
import WhyChoose from "../components/WhyChoose";
import HelpMeWith from "../components/HelpMeWith";
import Doctors from "../components/Doctors";
import DentalTourism from "../components/DentalTourism";
import Awards from "../components/Awards";
import FAQ from "../components/FAQ";
import Testimonials from "../components/Testimonials";
import Treatments from "../components/Treatments";
import BlogTeaser from "../components/BlogTeaser";
import CostCalculator from "../components/CostCalculator";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import FloatingButtons from "../components/FloatingButtons";

export default function Home() {
  return (
    <div className="relative">
      <Header />
      <main>
        <Hero />
        <Marquee />
        <About />
        <WhyChoose />
        <HelpMeWith />
        <Treatments />
        <Doctors />
        <DentalTourism />
        <CostCalculator />
        <Awards />
        <Testimonials />
        <BlogTeaser />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingButtons />
    </div>
  );
}
